
// Define i18n data for each language
//vi
import i18nCommon from './vi/i18nCommon';
import i18nProduct from './vi/product/i18nProduct';
import i18nDashboard from './vi/dashboard/i18nDashboard';

//en
import i18nCommonEn from './en/i18nCommon';
import i18nProductEn from './en/product/i18nProduct';
import i18nDashboardEn from './en/dashboard/i18nDashboard'

export default {
    vi: {
        i18nCommon,
        i18nProduct,
        i18nDashboard
    },

    en: {
        i18nCommon: i18nCommonEn,
        i18nProduct: i18nProductEn,
        i18nDashboard: i18nDashboardEn
    }
}